import { validationTypes } from 'components/FormCreator/types';
import { format } from 'date-fns';
import { Beneficiary } from './beneficiary.constants';
import { timing } from './ui.constants';

export enum paySteps {
	BENEFICIARY_DETAILS = 'beneficiary_details',
	PAYMENT_DETAILS = 'payment_details',
	REVIEW = 'review',
	COMPLETE = 'complete',
}

export enum paymentsTypes {
	LOCAL = 'regular',
	PRIORITY = 'priority',
}

export enum swiftTypes {
	SHARE = 'shared',
	OUR = 'ours',
}

export enum PaymentStatus {
	None = 'None',
	AwaitingFunds = 'AwaitingFunds',
	AwaitingAuthorization = 'AwaitingAuthorization',
	AwaitingAltshulerAuthorization = 'AwaitingAltshulerAuthorization',
	Deleted = 'Deleted',
	Approved = 'Approved',
	Completed = 'Completed',
	Failed = 'Failed',
	Rejected = 'Rejected',
}

export enum paymentReason {
	GOODS = 'Goods',
	SERVICES = 'Services',
	INVESTMENTS = 'Investments',
}

export enum payStepsStatus {
	notStarted = 'notStarted',
	inProgress = 'inProgress',
	pending = 'pending',
	error = 'error',
	completed = 'completed',
}

export enum PayEnum {
	createdAt = 'createdAt',
	updatedAt = 'updatedAt',
	dueDate = 'dueDate',
	settlementDate = 'settlementDate',
	id = 'id',
	beneficiaryId = 'beneficiaryId',
	beneficiary = 'beneficiary',
	amount = 'amount',
	paymentDate = 'paymentDate',
	paymentType = 'paymentType',
	paymentComment = 'paymentComment',
	swift = 'swift',
	paymentCategory = 'paymentCategory', // Payment category ID selected from dropdown
	comment = 'paymentComment',
	reference = 'paymentReference',
	invoiceNumber = 'invoiceNumber',
	invoiceFile = 'invoiceFile',
	companyId = 'companyId',
	currencyId = 'currencyId',
	fee = 'fee',
	iban = 'iban',
	status = 'status',
	complianceReference = 'complianceReference',
}

export interface Pay {
	[PayEnum.id]?: string;
	[PayEnum.beneficiaryId]?: number;
	[PayEnum.beneficiary]?: Beneficiary;
	[PayEnum.amount]?: number;
	[PayEnum.paymentDate]?: string | null;
	[PayEnum.paymentType]?: paymentsTypes;
	[PayEnum.paymentCategory]?: string; // Payment category ID
	[PayEnum.swift]: swiftTypes;
	[PayEnum.status]?: string;
	[PayEnum.comment]?: string;
	[PayEnum.paymentComment]?: string;
	[PayEnum.reference]?: string;
	[PayEnum.invoiceNumber]?: number;
	[PayEnum.invoiceFile]?: FileType[];
}

export const payIntialState = {
	[PayEnum.swift]: swiftTypes.SHARE,
	[PayEnum.paymentDate]: null,
};

export const PayDetails: PayEnum[] = [PayEnum.beneficiaryId, PayEnum.beneficiary, PayEnum.amount];

export const PayPreference: PayEnum[] = [PayEnum.paymentType, PayEnum.paymentDate];

export const PayReason: PayEnum[] = [
	PayEnum.invoiceNumber,
	PayEnum.invoiceFile,
	PayEnum.paymentCategory,
	PayEnum.reference,
	PayEnum.comment,
];

export const PayId: PayEnum = PayEnum.id;

export const fieldsValidations: { [key in keyof Partial<Pay>]: validationTypes[] } = {
	[PayEnum.beneficiaryId]: [validationTypes.requierd],
	[PayEnum.amount]: [validationTypes.requierd],
	[PayEnum.paymentType]: [validationTypes.requierd],
	[PayEnum.invoiceNumber]: [validationTypes.requierd],
	[PayEnum.invoiceFile]: [validationTypes.requierd],
	[PayEnum.paymentCategory]: [validationTypes.requierd],
	[PayEnum.reference]: [validationTypes.englishAndHebrewLettersAndDigits],
	[PayEnum.comment]: [validationTypes.englishAndDigits],
	[PayEnum.paymentDate]: [validationTypes.requierd],
};

export const PaymentCreateProps: PayEnum[] = [
	PayEnum.companyId,
	PayEnum.beneficiaryId,
	PayEnum.currencyId,
	PayEnum.amount,
	PayEnum.paymentDate,
	PayEnum.paymentType,
	PayEnum.paymentCategory, 
	PayEnum.comment,
	PayEnum.invoiceNumber,
	PayEnum.invoiceFile,
	PayEnum.reference,
	PayEnum.swift,
];

export const FieldsForReceipt: PayEnum[] = [
	PayEnum.amount,
	PayEnum.fee,
	PayEnum.iban,
	PayEnum.paymentType,
	PayEnum.paymentDate,
	PayEnum.paymentCategory,
	PayEnum.reference,
];

export type PaymentFees = {
	currencyId?: number;
	priority?: {
		ours?: string;
		shared?: string;
	};
	regular?: string;
};

export type FileType = {
	company_id: string;
	id: string;
	key: string;
	originalFileName: string;
	path: string;
};

export const paymentReasonList = {
	'1111': { label: 'reason 1', value: '1111' },
	'1112': { label: 'reason 2', value: '1112' },
	'1113': { label: 'reason 3', value: '1113' },
	'1114': { label: 'reason 4', value: '1114' },
	'1115': { label: 'reason 5', value: '1115' },
	'1116': { label: 'reason 6', value: '1116' },
	'1117': { label: 'reason 7', value: '1117' },
	'1118': { label: 'reason 8', value: '1118' },
	'1119': { label: 'reason 9', value: '1119' },
	'1110': { label: 'reason 10', value: '1110' },
};

export const MAX_INVOICE_FILES = 5;

// Keys produced by open-payment-server errorHandler: the CC error code text before `_is_`. Confirm codes in CC sandbox.
export const CcBeneficiaryAddressErrorKeys = {
	country: 'beneficiary_country',
	city: 'beneficiary_city',
};
